import {
	getPreferredVendorsRequest,
	getVendorsRequest,
	updatePreferredVendorRequest,
	newPreferredVendorRequest,
	deletePreferredVendorRequest,
} from '../requests';
import { objectGet, objectSet } from '@/core';
import rdbClient from 'rdb-client';
import deepCopy from 'deepcopy';

async function getPreferredVendors({ commit }) {
	commit('set', (state) => { state.loading = true; });
	try {
		await fetchPreferredVendors();
		await fetchVendors();
	} catch (err) {
		console.error(err);
		throw new Error('failedToFetch');
	}
	commit('set', (state) => { state.loading = false; });

	async function fetchPreferredVendors() {
		let response = await getPreferredVendorsRequest();
		commit('setPreferredVendors', response);
	}
	async function fetchVendors() {
		let response = await getVendorsRequest();
		commit('setCarrierVendors', response.filter(x => x.type === 'CARRIER' ));
	}
}

async function addPreferredVendor({ state, commit }) {
	let preferredVendor = {
		id: null,
		description: '',
		startPostalRange: '',
		endPostalRange: '',
		vendors: [],
	};
	try {
		let response = await newPreferredVendorRequest(preferredVendor);
		preferredVendor.id = response.id;
		let { preferredVendors } = state;
		preferredVendors.unshift(preferredVendor);
		commit('set', () => { state.preferredVendors = preferredVendors; });
	} catch (err) {
		throw new Error('failedToAdd');
	}

	return preferredVendor;
}

async function setPreferredVendor({ commit }, { preferredVendor, data, prop }) {
	let originalValue = objectGet(preferredVendor, prop);
	if (originalValue === data) return;

	let preferredVendorClone = deepCopy(preferredVendor);
	commit('set', () => { objectSet(preferredVendor, prop, data); });
	let patch = rdbClient.createPatch(preferredVendorClone, preferredVendor);
	try {
		await updatePreferredVendorRequest(preferredVendor.id, { patch });
		commit('clearErrors');
	} catch (err) {
		if (err.response) {
			commit('setErrors', { errors: err.response.data.errors, id: preferredVendor.id });
		}
		commit('set', () => { objectSet(preferredVendor, prop, originalValue); });
		throw (err);
	}
}

async function deletePreferredVendors({ state, commit }, preferredVendorsToDelete) {
	let storedPreferredVendors = state.preferredVendors;
	let idsToRemove = preferredVendorsToDelete.map( x => x.id );

	try {
		for (let preferredVendorId of idsToRemove) {
			await deletePreferredVendorRequest(preferredVendorId);
		}
		let updatedPreferredVendors = storedPreferredVendors.filter(term => idsToRemove.indexOf(term.id) < 0);
		commit('set', () => { state.preferredVendors = updatedPreferredVendors; });
	} catch (err) {
		throw new Error('failedToDelete');
	}
}

export default {
	getPreferredVendors,
	addPreferredVendor,
	setPreferredVendor,
	deletePreferredVendors,
};
